enum DiscountType {
    FIXED = 'fixed',
    PERCENT = 'percent',
}

export default DiscountType;
